__turbopack_context__.v({
  "copyButton": "Seed-module__7RY7eG__copyButton",
  "grid": "Seed-module__7RY7eG__grid",
  "root": "Seed-module__7RY7eG__root",
  "word": "Seed-module__7RY7eG__word",
  "wordLabel": "Seed-module__7RY7eG__wordLabel",
  "wordNumber": "Seed-module__7RY7eG__wordNumber",
});
